import { Controller } from "@hotwired/stimulus"

// Closes a <details> dropdown menu when the user clicks outside of it or presses Escape
export default class extends Controller {
    connect() {
        document.addEventListener("click", this.closeOnOutsideClick)
        document.addEventListener("keydown", this.closeOnEscape)
    }

    disconnect() {
        document.removeEventListener("click", this.closeOnOutsideClick)
        document.removeEventListener("keydown", this.closeOnEscape)
    }

    closeOnOutsideClick = (event) => {
        if (!this.element.contains(event.target)) this.element.removeAttribute("open")
    }

    closeOnEscape = (event) => {
        if (event.key === "Escape") this.element.removeAttribute("open")
    }
}
